import React, { useState } from 'react';
import API from '../../Services/api';
import { useNavigate } from 'react-router-dom';

const LoginStaff = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await API.post('/collection-staff/login', formData);
      if (response.data.token) {
        localStorage.setItem('staff-token', response.data.token);
        navigate('/staff-dashboard');
      } else {
        setMessage('Token missing from response');
      }
    } catch (error) {
      setMessage(error.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFB]">
      {/* Header */}
      <header className="bg-[#F8FAFB] border-b border-gray-200 px-6 py-4 flex items-center">
        <a href="/">
          <img src="/images/header_logo.png" alt="e-save Logo" className="h-10" />
        </a>
      </header>

      <div className="flex-grow flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-md p-8">
          {/* Icon */}
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 rounded-full bg-[#EEFAF7] flex items-center justify-center">
              <img src="/images/Recycle_bin.png" alt="Staff" className="w-8 h-8" />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-center text-[#172A3A] mb-1">Staff Login</h2>
          <p className="text-sm text-center text-[#6E7C87] mb-6">Access the e-save staff dashboard</p>

          <form onSubmit={handleSubmit}>
            <label className="block text-sm font-medium text-[#414042] mb-1">Email address</label>
            <input
              name="email"
              type="email"
              placeholder="staff@example.com"
              onChange={handleChange}
              required
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#29752B]"
            />
            <label className="block text-sm font-medium text-[#414042] mb-1">Password</label>
            <input
              name="password"
              type="password"
              placeholder="••••••••"
              onChange={handleChange}
              required
              className="w-full px-4 py-2 mb-6 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#29752B]"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#29752B] text-white py-2.5 rounded-lg font-semibold hover:bg-[#18421B] transition-colors disabled:opacity-60"
            >
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          {message && (
            <p className="mt-4 text-center text-sm text-red-500">{message}</p>
          )}

          <p className="mt-6 text-center text-sm text-[#6E7C87]">
            Not a staff member?{' '}
            <a href="/" className="text-[#29752B] font-medium hover:underline">Go to main site</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginStaff;
